import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useAppData } from '../AppContext';
import './Hero.css';

const Hero = () => {
  const { heroSlides } = useAppData();
  return (
    <>
      <section className="hero-swiper-section">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5200, disableOnInteraction: false }}
          loop
          speed={700}
          className="hero-swiper"
        >
          {heroSlides.map((slide, i) => (
            <SwiperSlide key={slide.id ?? i}>
              <div className="hero-slide">
                <img src={slide.img} alt={slide.title} className="hero-slide-img" />
                <div className="hero-slide-overlay">
                  <div className="hero-slide-content">
                    <span className="hero-slide-tag">{slide.tag}</span>
                    <h1 className="hero-slide-title">{slide.title}</h1>
                    <p className="hero-slide-caption">{slide.caption}</p>
                    <div className="hero-slide-actions">
                      <Link to={slide.btn1Link || '/products'} className="hero-btn-primary">{slide.btn1Text || 'Explore Products'}</Link>
                      <Link to={slide.btn2Link || '/contact'} className="hero-btn-secondary">{slide.btn2Text || 'Get a Quote'}</Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className="zinga-intro-section">
        <div className="zinga-intro-container">
          <div className="zinga-intro-text" data-aos="fade-right" data-aos-duration="800">
            <div className="zinga-badge">ZINGA® Technology</div>
            <h2>
              ZINGA<sup>®</sup> is an anti-corrosive, single-component, high-performance
              metallic coating that promotes a cathodic film protection system. It contains{' '}
              <strong>96% zinc in its dry film</strong>, with a high content of metallic zinc (97%)
              and high purity (99.995%).
            </h2>
            <p className="zinga-tagline">Zinga provides galvanisation on your structure as easily as applying paint!</p>
          </div>
          <div className="zinga-intro-media" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            <div className="corrosion-solution-box">
              <div className="search-bar-demo">
                <span>corrosion solution</span>
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </div>
              <ul className="solution-list">
                <li>Surface treatments</li>
                <li>Applied coatings</li>
                <li>Reactive coatings</li>
                <li>Anodization</li>
                <li>Active protection</li>
                <li>Biofilm coatings</li>
                <li>Controlled permeability formwork</li>
                <li>Cathodic protection</li>
                <li>Sacrificial anodic protection</li>
                <li>Impressed current cathodic protection</li>
                <li>Anodic protection</li>
                <li>Passive protection</li>
                <li>Rate of corrosion</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
